import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  ListItemIcon,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SidebarItem from "./SidebarItem";

const SidebarAccordion = ({
  item,
  index,
  open,
  auth,
  selectedItem,
  handleListItemClick,
  location,
}) => {
  return (
    <Accordion
      disableGutters
      sx={{
        boxShadow: "none",
        backgroundColor: "transparent",
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel-${index}-content`}
        id={`panel-${index}-header`}
      >
        <ListItemIcon sx={{ color: "#463812" }}>
          <item.icons />
        </ListItemIcon>
        <Typography sx={{ fontWeight: 600, fontSize: "15px" }}>
          {item.text}
        </Typography>
      </AccordionSummary>

      <AccordionDetails sx={{ ml: 1 }}>
        {item.children.map((child, childIdx) => (
          <SidebarItem
            key={`${index}-${childIdx}`}
            item={child}
            index={`${index}-${childIdx}`}
            open={open}
            auth={auth}
            selectedItem={selectedItem}
            handleListItemClick={handleListItemClick}
            location={location}
            isChild
          />
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default React.memo(SidebarAccordion);
